<template>
  <div style="">
    <a-card :bordered="false" style="margin-top:10px;box-shadow:0px 1px 10px 0px rgba(0,0,0,0.06);">
      <a-tabs defaultActiveKey="1" @change="callback">
        <a-tab-pane tab="账号" key="1">
          <StaffAccountList></StaffAccountList>
        </a-tab-pane>
        <a-tab-pane tab="角色" key="2" forceRender>
          <StaffRolesList></StaffRolesList>
        </a-tab-pane>
      </a-tabs>
    </a-card>
  </div>
</template>
<script>
// import { JeecgListMixin } from '@/mixins/JeecgListMixin'


import StaffAccountList from '../../components/accountManage/staffAccountManage/StaffAccountList'
import StaffRolesList from '../../components/accountManage/staffAccountManage/StaffRolesList'

export default {
  name: 'StaffAccountManage',
  mixins: [],
  components: {StaffAccountList,StaffRolesList},

  data() {
    return {
      description: '员工账号页面',
      
      // 请求参数
      url: {
        // list: "/course/elinkxCourse/list",
        // delete: '/course/elinkxCourse/delete',
        // deleteBatch: '/course/elinkxCourse/deleteBatch',
        // exportXlsUrl: 'course/elinkxCourse/exportXls',
        // importExcelUrl: 'course/elinkxCourse/importExcel'
      }
    }
  },
  computed: {
    importExcelUrl: function() {
      // return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    }
  },

  methods: {
    callback:()=>{
    }
  }
}
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
<style lang="scss" scoped >


</style>